export const knownCurrencies = [
  'USD',
  'EUR',
  'GBP',
  'JPY',
  'KRW',
  'CHF',
  'CAD',
  'AUD',
  'BRL',
  'SGD',
]

export type Token = { formatted: string; symbol: string }

/** Format a token amount as fiat currency if the symbol contains a known currency, otherwise as crypto. */
export function fiat(token: Token, options: { maxDecimals?: number | undefined } = {}): string {
  const currency = inferCurrency(token.symbol)
  if (currency)
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      maximumFractionDigits: Math.max(2, options.maxDecimals ?? 4),
    }).format(Number.parseFloat(token.formatted))
  return crypto(token, options)
}

/** Format a token amount with its symbol (e.g. "1,000.00 WETH"). */
export function crypto(token: Token, options: { maxDecimals?: number | undefined } = {}): string {
  const n = Number.parseFloat(token.formatted)
  const formatted = Number.isNaN(n)
    ? token.formatted
    : new Intl.NumberFormat('en-US', {
        maximumFractionDigits: options.maxDecimals ?? 20,
        minimumFractionDigits: 2,
      }).format(n)
  return `${formatted} ${token.symbol}`
}

/** Infer an ISO 4217 currency code from a token symbol (e.g. "PathUSD" → "USD"). */
export function inferCurrency(symbol: string): string | undefined {
  const upper = symbol.toUpperCase()
  return knownCurrencies.find((c) => upper.includes(c))
}

/** Returns the currency symbol (e.g. "$") for a token symbol when one can be inferred. */
export function currencySymbol(symbol: string): string | undefined {
  const currency = inferCurrency(symbol)
  if (!currency) return undefined
  return new Intl.NumberFormat('en-US', { style: 'currency', currency })
    .formatToParts(0)
    .find((p) => p.type === 'currency')?.value
}
